import React, { useState } from 'react';
import { Container, Row, Col, Tab, Tabs } from 'react-bootstrap';
import { FaUser, FaBuilding, FaFileAlt, FaQuestionCircle, FaCreditCard, FaCar } from 'react-icons/fa';

const FAQTabs = ({
    showTitle = true,
    title = "Sorularla Otoprime'i Tanı",
    showContainer = true,
    defaultActiveTab = 'general',
    customTabs = null,
    centerTabs = true,
    id = "faq-section",
    className = ""
}) => {
    const [activeTab, setActiveTab] = useState(defaultActiveTab);

    // Kapsamlı FAQ içerikleri
    const defaultTabContents = {
        general: [
            {
                id: 0,
                question: "Otoprime nedir ve nasıl çalışır?",
                answer: "Otoprime, alternatif araç finansman çözümleri sunan Türkiye'nin lider platformudur. Kredi notu düşük olan müşterilerimize senetli taksit imkanı sunarak, araç sahibi olmalarını sağlıyoruz. 2020'den beri hizmet vermekteyiz."
            },
            {
                id: 1,
                question: "Hangi şehirlerde hizmet veriyorsunuz?",
                answer: "Şu anda İstanbul merkezli hizmet vermekteyiz. Ancak diğer şehirlerden de müşterilerimizi kabul ediyoruz. Araç teslimi ve evrak işlemleri için İstanbul'a gelmeniz gerekebilir."
            },
            {
                id: 2,
                question: "Araçlarınız ekspertizli mi?",
                answer: "Evet, tüm araçlarımız detaylı ekspertiz raporlu ve kilometresi garantilidir. Her araç satış öncesi teknik kontrolden geçirilir ve raporlanır."
            },
            {
                id: 3,
                question: "Araç görme randevusu nasıl alırım?",
                answer: "Web sitemiz üzerinden veya telefonla randevu alabilirsiniz. Randevu saatlerimiz: Pazartesi-Cumartesi 09:00-18:00 arası."
            },
            {
                id: 4,
                question: "Araç değişim/iade politikanız var mı?",
                answer: "Araç alım-satım sürecinde, ekspertiz ve test imkanlarıyla müşterilerimizin en doğru kararı vermesine destek oluyoruz. Bu nedenle iade veya değişim uygulamamız bulunmamaktadır. Satış öncesi şeffaflık ve güven bizim için önceliklidir."
            }
        ],
        financing: [
            {
                id: 0,
                question: "Senetli taksit sistemi nasıl çalışır?",
                answer: "Kredi notu düşük müşterilerimiz için geliştirdiğimiz sistem. Belirli bir peşinat ödemesi ile kalan tutarı 12-36 ay arasında senetlerle ödeyebilirsiniz. Faiz oranları bankalardan daha düşüktür."
            },
            {
                id: 1,
                question: "Peşinat oranı nedir?",
                answer: "Minimum %30 peşinat gereklidir. Peşinat tutarı ne kadar yüksek olursa, aylık taksit tutarınız o kadar düşük olur."
            },
            {
                id: 2,
                question: "Vade seçenekleri nelerdir?",
                answer: "12, 18, 24, 30 ve 36 aylık vade seçeneklerimiz bulunmaktadır. Vade uzadıkça aylık ödeme tutarı düşer."
            },
            {
                id: 3,
                question: "Erken ödeme yapabilir miyim?",
                answer: "Evet, erken ödeme yapabilirsiniz. Erken ödeme durumunda kalan faiz tutarında indirim uygulanır."
            },
            {
                id: 4,
                question: "Taksit ödemelerini nerede yapabilirim?",
                answer: "Taksitlerinizi bankaya EFT/havale veya ofisimize nakit olarak ödeyebilirsiniz. Otomatik ödeme talimatı da verebilirsiniz."
            },
            {
                id: 5,
                question: "Gecikme durumunda ne olur?",
                answer: "Ödeme gecikmelerinde önce müşterimizle iletişime geçeriz. Makul süre tanınır ve ödeme planı revize edilebilir."
            }
        ],
        requirements: [
            {
                id: 0,
                question: "Başvuru için genel şartlar nelerdir?",
                answer: "18-65 yaş arası, düzenli geliri olan, Türkiye Cumhuriyeti vatandaşı olmak gereklidir. Kredi notu şartı yoktur."
            },
            {
                id: 1,
                question: "Gelir şartı var mı?",
                answer: "Minimum aylık 15.000 TL düzenli gelir gereklidir. Bu miktar maaş, emekli maaşı, kira geliri gibi kaynaklardan olabilir."
            },
            {
                id: 2,
                question: "Kefil gerekli mi?",
                answer: "Genellikle kefil gerekmez, ancak başvuru durumuna göre 1 kefil istenebilir. Kefil de aynı gelir şartlarını sağlamalıdır."
            },
            {
                id: 3,
                question: "Sigorta zorunlu mu?",
                answer: "Evet, kasko sigortası zorunludur. Sigorta masrafları müşteriye aittir. Anlaşmalı sigorta şirketlerimizden avantajlı fiyatlarla yaptırabilirsiniz."
            }
        ],
        individual: [
            {
                id: 0,
                question: "Bireysel müşteriler için istenen belgeler nelerdir?",
                answer: "• Kimlik fotokopisi\n• Maaş bordrosu (son 3 ay)\n• Findex raporu\n• İkametgah belgesi\n• Varsa üzerine kayıtlı araç ruhsatları\n• Varsa üzerine kayıtlı tapu fotokopileri"
            },
            {
                id: 1,
                question: "Emekliler için ek belgeler var mı?",
                answer: "Emekliler için maaş bordrosu yerine emekli maaşı bordrosu (son 3 ay) ve SGK hizmet dökümü gereklidir."
            },
            {
                id: 2,
                question: "Serbest meslek sahipleri için gerekenler?",
                answer: "• Vergi levhası\n• Gelir belgeleri (son 6 ay banka hesap özeti)\n• Vergi dairesi beyannamesi\n• Ticaret sicil belgesi (varsa)\n• Faaliyetini gösteren belgeler"
            },
            {
                id: 3,
                question: "Çiftçiler için istenen belgeler?",
                answer: "• Çiftçi kayıt belgesi\n• Tarımsal gelir belgeleri\n• Ürün satış faturaları\n• Ziraat odası belgesi\n• Arazi tapu fotokopileri"
            }
        ],
        corporate: [
            {
                id: 0,
                question: "Firmalar için istenen belgeler nelerdir?",
                answer: "• Vergi levhası\n• İmza sirküleri\n• Firma yetkililerinin kimlik fotokopileri\n• Faaliyet belgesi\n• Son 2 yılın mali verileri\n• Varsa araç ruhsatları\n• Varsa tapu fotokopileri\n• Findeks raporu"
            },
            {
                id: 1,
                question: "Limited şirketler için ek belgeler?",
                answer: "• Ticaret sicil gazetesi\n• Şirket ana sözleşmesi\n• Ortaklar kurulu kararı (araç alımı için)\n• Ortakların kimlik ve ikametgah belgeleri"
            },
            {
                id: 2,
                question: "Anonim şirketler için gerekenler?",
                answer: "• Ticaret sicil gazetesi\n• Ana sözleşme ve tadiller\n• Yönetim kurulu kararı\n• İmza yetkililerin belgeler\n• Sermaye yapısı belgesi"
            },
            {
                id: 3,
                question: "Şahıs firmaları için belgeler?",
                answer: "• Vergi levhası\n• Ticaret sicil belgesi\n• İşyeri açma ruhsatı\n• Gelir belgeleri\n• Firma sahibinin kimlik belgesi"
            },
            {
                id: 4,
                question: "Kurumsal müşteriler için özel avantajlar var mı?",
                answer: "Evet, kurumsal müşterilerimize özel vade seçenekleri, filo indirimleri ve ek hizmetler sunuyoruz. Detaylar için iletişime geçin."
            }
        ],
        process: [
            {
                id: 0,
                question: "Başvuru süreci nasıl işler?",
                answer: "✅ 1. Adım: İstediğiniz aracı Otoprime'den veya başka galeriden beğenin.\n\n💰 2. Adım: Araç bedelinin %30'u kadar peşinatınızı hazırlayın. Ne kadar erken, o kadar çabuk yola çıkarsınız!\n\n📞 3. Adım: Online formu doldurun ya da bizi arayın. Evraklarınızı hazırlayın, süreci başlatın!\n\n⏱️ 4. Adım: Başvurunuzu aldıktan sonra birkaç saat içinde size dönüş yapıyoruz.\n\n🔑 5. Adım: TSE onaylı ekspertiz tamamlandıktan sonra, banka güvencesindeki senetler imzalanıp noter işlemleri yapılır.\n\n🎉 6. Adım: Ve mutlu son! Anahtar cebinizde, araç artık sizin! Alım süreci tamamlandı. Aracınız hazır, yol sizi bekliyor!"
            },
            {
                id: 1,
                question: "Başvuru değerlendirme süresi ne kadar?",
                answer: "Evraklar eksiksiz teslim edildikten sonra 1-2 saat içinde başvurunuz değerlendirilir ve sonuç bildirilir."
            },
            {
                id: 2,
                question: "Onay aldıktan sonra işlem tamamlama süresi?",
                answer: "Gerekli evraklar hazır ise sözleşme ve senet işlemleri 4 dakika içinde tamamlanır. Araç teslimi aynı gün yapılabilir."
            },
            {
                id: 3,
                question: "Araç tescil işlemleri nasıl yapılır?",
                answer: "Tescil işlemlerini firmamız yapar. Müşterimizin sadece kimlik belgesi ile hazır bulunması yeterlidir."
            },
            {
                id: 4,
                question: "Plakalama işlemi ne kadar sürer?",
                answer: "Trafik tescil işlemleri genellikle aynı gün tamamlanır. Yoğunluk durumunda 1-2 gün sürebilir."
            }
        ]
    };

    // Özel veya varsayılan sekme içeriklerini kullan
    const tabContents = customTabs || defaultTabContents;

    // Sekme başlıkları ve ikonları
    const tabConfig = {
        general: { title: "Genel Sorular", icon: FaQuestionCircle },
        financing: { title: "Finansman", icon: FaCreditCard },
        requirements: { title: "Şartlar", icon: FaFileAlt },
        individual: { title: "Bireysel Belgeler", icon: FaUser },
        corporate: { title: "Kurumsal Belgeler", icon: FaBuilding },
        process: { title: "Süreç", icon: FaCar }
    };

    // İçerik bileşeni
    const TabContent = ({ tabKey }) => (
        <Row className="justify-content-center">
            <Col lg={10}>
                <div className="modern-faq-list">
                    {tabContents[tabKey].map((item) => (
                        <div key={item.id} className="modern-faq-item">
                            <h4 className="modern-faq-question">{item.question}</h4>
                            <div className="modern-faq-answer">
                                {item.answer.split('\n').map((line, index) => (
                                    <p key={index} style={{ whiteSpace: 'pre-line' }}>
                                        {line}
                                    </p>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </Col>
        </Row>
    );

    // İçerik bölümü
    const Content = () => (
        <>
            {showTitle && (
                <div className="text-center mb-5">
                    <h2 className="section-title">{title}</h2>
                    <p className="lead">Kategori seçerek ilgili soruları görüntüleyebilirsiniz</p>
                </div>
            )}

            <Tabs
                activeKey={activeTab}
                onSelect={(k) => setActiveTab(k)}
                id={`${id}-tabs`}
                className={`mb-5 ${centerTabs ? 'justify-content-center' : ''}`}
            >
                {Object.keys(tabContents).map((tabKey) => {
                    const config = tabConfig[tabKey] || { title: tabKey, icon: FaQuestionCircle };
                    const IconComponent = config.icon;

                    return (
                        <Tab
                            key={tabKey}
                            eventKey={tabKey}
                            title={
                                <span className="d-flex align-items-center">
                                    <IconComponent className="me-2" />
                                    <span className="d-none d-md-inline">{config.title}</span>
                                    <span className="d-md-none">{config.title.split(' ')[0]}</span>
                                </span>
                            }
                        >
                            <TabContent tabKey={tabKey} />
                        </Tab>
                    );
                })}
            </Tabs>
        </>
    );

    // Container ile veya Container'sız render
    return (
        <section className={`faq-tabs-section py-5 ${className}`} id={id}>
            {showContainer ? (
                <Container>
                    <Content />
                </Container>
            ) : (
                <Content />
            )}
        </section>
    );
};

export default FAQTabs;